import { render } from "./wind.vue?vue&type=template&id=45db6e7b&scoped=true"
import script from "./wind.vue?vue&type=script&lang=js"
export * from "./wind.vue?vue&type=script&lang=js"

import "./wind.vue?vue&type=style&index=0&id=45db6e7b&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45db6e7b"]])

export default __exports__